import { Avatar, Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover, Stack, Typography } from '@mui/material';
import './navigation.scss';
import { AccountCircle, Logout, Menu } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { COLORS } from '../../settings/themeSettings';
import { apilogout } from '../../auth/useToken';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMe } from '../../data/slices/currentUserSlice';



const styles = {
    navbar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        padding: '0px 10px',
        bgcolor: COLORS.secondary,
        position: 'sticky', // Barre fixe selon la note de cadrage
        top: 0,
        zIndex: 1100, // Au-dessus du contenu
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)' // Ombre pour la lisibilité
    },
    title: { 
        fontWeight: 'bold', 
        fontFamily: 'Roboto', 
        color: 'white',
        fontSize: '1.2rem' // Réduit encore plus pour s'adapter à la navbar plus petite
    },
    avatar: {
        bgcolor: 'white',
        cursor: 'pointer',
        width: '30px', // Réduit de 36px à 30px
        height: '30px'
    }
}


const NavigationBar = ({ onHambergerClick }) => {
    const { me } = useSelector((state) => state.me);
    const dispatch = useDispatch();


    const [anchorEl, setAnchorEl] = useState(null);
    const navigateTo = useNavigate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        //navigateTo('/login')
        apilogout(navigateTo);
    }

    useEffect(() => {
        dispatch( fetchMe()) ;
    }, [dispatch]);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    return <div className="navigation-bar">
        <Box sx={styles.navbar}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 6 // Réduit pour une meilleure compacité

                }}

            >    <Menu style={{
                fill: 'white', 
                fontSize: '1.5em', // Réduit de 1.8em à 1.5em pour s'adapter
                cursor: 'pointer',
            }}  
            onClick={onHambergerClick}
            className="menu-icon"
            />

                <Typography variant='h4' sx={styles.title}>Travel Manager</Typography>

            
            </div>

            <Stack direction="row" justifyContent="space-between" alignItems="center">
              {me?.nomComplet &&  <Typography variant='h6' sx={{
                  mr: 2, // Réduit de 3 à 2 pour plus de compacité
                  fontSize: '0.7rem', // Réduit encore plus pour s'adapter à la navbar plus petite
                  color: '#FFF'
              }}>Bonjour, {me.nomComplet} !</Typography>}

              <Avatar sx={styles.avatar} aria-describedby={id} onClick={handleClick}>
                <AccountCircle style={{ fill: COLORS.secondary }} />
            </Avatar>
            </Stack>
          



            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >

                <nav aria-label="main mailbox folders">
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={logout}>
                                <ListItemIcon>
                                    <Logout style={{ fill: COLORS.secondary }} />
                                </ListItemIcon >
                                <ListItemText primary={
                                    <Typography style={{ color: COLORS.secondary }}>Déconnexion</Typography>
                                } />
                            </ListItemButton>
                        </ListItem>

                    </List>
                </nav>




            </Popover>
        </Box>

    </div>

}


export default NavigationBar;
